export { default } from './useScreenRecognition';
